<template>
  <div
    class="sidebar-item hasChildren"
    :class="{ open: state.isOpen, current: currentRoute }"
  >
    <div class="primary-wrapper" @click="toggleFetch">
      <img
        :src="
          space.image_id
            ? getImage(space.image_id)
            : getRandomSpacePicture(space.name)
        "
        alt="Logo"
        class="spaceLogo"
      />
      <transition-group name="fade">
        <span v-if="animationIsFinished && sidebarIsOpen" v-text="space.name" />
        <i
          v-if="animationIsFinished && sidebarIsOpen"
          class="bi bi-chevron-down toggle-children"
        />
      </transition-group>
    </div>
    <div
      class="children-wrapper"
      :style="{ height: `${childrenWrapperHeight}px` }"
    >
      <template v-if="spaceCampaigns.length">
        <router-link
          v-for="(item, index) in spaceCampaigns"
          :key="index"
          :to="{
            name: 'campaign',
            params: {
              spaceId: item.workspace_id,
              campaignId: item.campaign_id,
            },
          }"
          class="children-item"
        >
          <span v-text="item.name" />
        </router-link>
      </template>
      <template v-else>
        <p class="children-item disabled">Aucune campagne</p>
      </template>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { computed, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import { useCampaignStore } from "@/stores/campaign.js";
import { useCompanyStore } from "@/stores/company.js";
import { useSpaceStore } from "@/stores/space.js";
import { getImage, getRandomSpacePicture } from "@/composables/getImage.js";

const route = useRoute();

const campaignStore = useCampaignStore();

const { campaigns } = storeToRefs(campaignStore);

const { currentCompany } = useCompanyStore();

const spaceStore = useSpaceStore();

const { spaces } = storeToRefs(spaceStore);

const props = defineProps({
  space: {
    type: Object,
    required: true,
  },
  animationIsFinished: {
    type: Boolean,
    required: true,
  },
  sidebarIsOpen: {
    type: Boolean,
    required: true,
  },
});

const state = reactive({
  isLoading: false,
  isOpen: false,
});

const currentRoute = computed(() => {
  if (!spaceCampaigns.value) return false;

  return spaceCampaigns.value.find(
    (child) => child.campaign_id === route.params.campaignId
  );
});

const spaceCampaigns = computed(() => {
  return campaigns.value.filter(
    (campaign) =>
      campaign.workspace_id === props.space.workspace_id && !campaign.archived
  );
});

const childrenWrapperHeight = computed(() => {
  if (!state.isOpen || !spaceCampaigns.value) return 0;

  const childHasDivider = spaceCampaigns.value.filter((child) => child.divider);

  let nbchild =
    childHasDivider.length > 0
      ? spaceCampaigns.value.length + 1
      : spaceCampaigns.value.length;

  nbchild = nbchild === 0 ? 1 : nbchild;

  // Nb of child with 20px height + gap of 16px between
  return nbchild * 20 + (nbchild - 1) * 16;
});

watch(props, () => {
  if (!props.sidebarIsOpen) {
    state.isOpen = false;
  }
});

async function toggleFetch() {
  state.isOpen = !state.isOpen;

  if (state.isOpen) {
    state.isLoading = true;

    if (!props.space?.fetchedCampaigns) {
      const spaceIndex = spaces.value.findIndex(
        (space) => space.workspace_id === props.space.workspace_id
      );

      const req = await campaignStore.getCampaigns(
        currentCompany.company_id,
        props.space.workspace_id
      );

      if (!req.code) spaces.value[spaceIndex].fetchedCampaigns = true;
    }

    state.isLoading = false;
  }
}
</script>
